var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"health mx-3"},[_c('bread-crumbs'),(_vm.showDashboard)?_c('report-list'):_c('v-row',{staticClass:"health-report-content"},[_c('v-col',{staticClass:"health-report"},[_c('data-table',{ref:"table",attrs:{"actions":_vm.actions}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }